import { FilterInfo, SurveyInfo } from 'lib-shared-types-api';

import { FilterLink, SurveyLink } from '../shared';

type MatchedButNotSelectedStatusProps = {
  filter: FilterInfo;
  survey: SurveyInfo;
  contactPointLabel: string;
};

/**
 * Displays status for filters that matched but weren't selected as the final
 * choice.
 */
export const MatchedButNotSelectedStatus = ({
  filter,
  survey,
  contactPointLabel,
}: MatchedButNotSelectedStatusProps): JSX.Element => {
  return (
    <>
      Filter: <FilterLink filter={filter} /> triggered and the delivery of{' '}
      <SurveyLink survey={survey} /> via {contactPointLabel} was matched but NOT
      SELECTED
    </>
  );
};
